import React, { useState } from 'react';
import { getAppUrl } from '@drayalliance/utils';
import PropTypes from 'prop-types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import UserIcon from '@components/deprecatedTookit/icons/fa/regular/UserIcon';
import MoneyBillIcon from '@components/deprecatedTookit/icons/fa/regular/MoneyBillIcon';
import BoxesIcon from '@components/deprecatedTookit/icons/fa/regular/BoxesIcon';
import ClockIcon from '@components/deprecatedTookit/icons/fa/regular/ClockIcon';
import WarehouseIcon from '@components/deprecatedTookit/icons/fa/regular/WarehouseIcon';
import MoneyBillAltIcon from '@components/deprecatedTookit/icons/fa/regular/MoneyBillAltIcon';
import FileInvoiceIcon from '@components/deprecatedTookit/icons/fa/regular/FileInvoiceIcon';
import Drawer from '../Drawer';
import SidebarNavLink from '../SidebarNavLink';
import history from '../../utils/history';

import './style.css';

function LeftSidebar(props) {
  const featureFlags = useFlags();
  const anySidebarOpen = props.arApOpen || props.open;
  const [state, setState] = useState({
    selectedNavLinkId: props.location.pathname
  });
  let contentClassName = 'left-sidebar__drawer-content';
  let overlayClassName = 'left-sidebar__drawer-overlay';

  state.selectedNavLinkId = props.location.pathname;

  if (!anySidebarOpen) {
    contentClassName += ' left-sidebar--hidden';
    overlayClassName += ' left-sidebar--hidden';
  }

  const handleNavLinkClick = (cProps) => {
    const path = cProps.id;

    setState({
      selectedNavLinkId: path
    });

    history.push(path);

    if (props.onClose) {
      props.onClose();
    }
  };

  const isNavLinkSelected = (path) => {
    const result = state.selectedNavLinkId.includes(path);

    return result;
  };

  let navItems;

  const showPayFormulaLink = featureFlags.pricingFormulaUpdate;
  const { bulkInvoiceCreation } = featureFlags;

  if (props.open) {
    navItems = (
      <>
        <div className="left-sidebar__group-title">Accounts</div>
        <SidebarNavLink
          value="Accounts"
          wasMigrated
          icon={<WarehouseIcon />}
          id={`${props.match.path}/settings/accounts`}
          selected={isNavLinkSelected(`${props.match.path}/settings/accounts`)}
          onClick={() => {
            window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/administration/accounts`);
          }}
        />
        <SidebarNavLink
          value="People"
          wasMigrated
          icon={<UserIcon />}
          id={`${props.match.path}/settings/people`}
          selected={isNavLinkSelected(`${props.match.path}/settings/people`)}
          onClick={() => {
            window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/administration/people`);
          }}
        />
        <div className="left-sidebar__group-title">Carrier</div>
        <SidebarNavLink
          value="Rating Rules"
          wasMigrated
          icon={<MoneyBillIcon />}
          id={`${props.match.path}/settings/carrier-rating-rules`}
          selected={isNavLinkSelected(`${props.match.path}/settings/carrier-rating-rules`)}
          onClick={() => {
            window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/administration/rating-rules`);
          }}
        />
        {showPayFormulaLink && (
          <SidebarNavLink
            value="Current Pricing"
            wasMigrated
            icon={<MoneyBillIcon />}
            id={`${props.match.path}/settings/pay-formulas`}
            selected={isNavLinkSelected(`${props.match.path}/settings/pay-formulas`)}
            onClick={() => {
              window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/finances/current-pricing`);
            }}
          />
        )}
        <SidebarNavLink
          value="Future Pricing"
          wasMigrated
          icon={<MoneyBillIcon />}
          id={`${props.match.path}/settings/future-pricing-formulas`}
          selected={isNavLinkSelected(`${props.match.path}/settings/future-pricing-formulas`)}
          onClick={() => {
            window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/finances/current-pricing`);
          }}
        />
        <div className="left-sidebar__group-title">AP Rules</div>
        <SidebarNavLink
          value="Accessorial"
          wasMigrated
          icon={<MoneyBillIcon />}
          id={`${props.match.path}/settings/ap-accessorial-fees`}
          selected={isNavLinkSelected(`${props.match.path}/settings/ap-accessorial-fees`)}
          onClick={() => {
            window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/finances/ap-accessorials`);
          }}
        />
        <SidebarNavLink
          value="Per Diem"
          wasMigrated
          icon={<MoneyBillAltIcon />}
          id={`${props.match.path}/settings/per-diem`}
          selected={isNavLinkSelected(`${props.match.path}/settings/per-diem`)}
          onClick={() => {
            window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/finances/per-diem-rules`);
          }}
        />

        {/* <SidebarNavLink
          value="Chassis Rule"
          icon={<MoneyBillIcon />}
          id={`${props.match.path}/settings/ap-chassis-fees`}
          selected={isNavLinkSelected(`${props.match.path}/settings/ap-chassis-fees`)}
          onClick={handleNavLinkClick}
        /> */}
        <div className="left-sidebar__group-title">AR Rules</div>
        <SidebarNavLink
          value="Accessorial"
          wasMigrated
          icon={<MoneyBillAltIcon />}
          id={`${props.match.path}/settings/ar-accessorial-fees`}
          selected={isNavLinkSelected(`${props.match.path}/settings/ar-accessorial-fees`)}
          onClick={() => {
            window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/finances/ar-accessorials`);
          }}
        />
        <SidebarNavLink
          value="Base Rate"
          wasMigrated
          icon={<MoneyBillAltIcon />}
          id={`${props.match.path}/settings/base-rates`}
          selected={isNavLinkSelected(`${props.match.path}/settings/base-rates`)}
          onClick={() => {
            window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/finances/base-rates`);
          }}
        />
        <SidebarNavLink
          value="Chassis Fees"
          wasMigrated
          icon={<MoneyBillAltIcon />}
          id={`${props.match.path}/settings/chassis-fees`}
          selected={isNavLinkSelected(`${props.match.path}/settings/chassis-fees`)}
          onClick={() => {
            window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/finances/ar-chassis-fees`);
          }}
        />
        <SidebarNavLink
          value="Grace Period"
          icon={<MoneyBillAltIcon />}
          id={`${props.match.path}/settings/grace-period`}
          selected={isNavLinkSelected(`${props.match.path}/settings/grace-period`)}
          onClick={handleNavLinkClick}
        />
      </>
    );
  } else if (props.arApOpen) {
    navItems = (
      <>
        <div className="left-sidebar__group-title">Customer Invoicing</div>
        <SidebarNavLink
          value="Waiting for Payment"
          icon={<ClockIcon />}
          id={`${props.match.path}/ar-ap/waiting-for-payment`}
          selected={isNavLinkSelected(`${props.match.path}/ar-ap/waiting-for-payment`)}
          onClick={handleNavLinkClick}
        />
        <SidebarNavLink
          value="Shipper Invoice"
          icon={<ClockIcon />}
          id={`${props.match.path}/ar-ap/shipper-invoice`}
          selected={isNavLinkSelected(`${props.match.path}/ar-ap/shipper-invoice`)}
          onClick={handleNavLinkClick}
        />
        {bulkInvoiceCreation && (
          <SidebarNavLink
            value="Bulk Invoice Generation"
            icon={<BoxesIcon />}
            id={`${props.match.path}/ar-ap/bulk-invoice-generation`}
            selected={isNavLinkSelected(`${props.match.path}/ar-ap/bulk-invoice-generation`)}
            onClick={handleNavLinkClick}
          />
        )}
        <div className="left-sidebar__group-title">Per Diem</div>
        <SidebarNavLink
          value="Actual Per Diem"
          icon={<FileInvoiceIcon />}
          id={`${props.match.path}/ar-ap/per-diem/actual-per-diem`}
          selected={isNavLinkSelected(`${props.match.path}/ar-ap/per-diem/actual-per-diem`)}
          onClick={handleNavLinkClick}
        />
      </>
    );
  }

  return (
    <Drawer
      anchor="left"
      contentClassName={contentClassName}
      overlayClassName={overlayClassName}
      open={anySidebarOpen}
      onClose={props.onClose}
    >
      {navItems}
    </Drawer>
  );
}

LeftSidebar.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  open: PropTypes.bool,
  arApOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default React.memo(LeftSidebar);
